import React from "react"
import EditorialPageContainer from "../containers/editorialPage"
import { SeoContents } from "../features/seo/components/PageSEO"
import PageNotFoundContainer from "../containers/errors/PageNotFoundContainer"
import GenericSEO from "../features/seo/components/GenericSEO"
import { wrapPage } from "../aggregators/page"
import { fetchEditorialPageData } from "../contents/editorialPage/fetch"
import { faqQuery } from "../contents/editorialPage/queries"
import { DefaultLayout } from "../layouts/Default/DefaultLayout"
import { WrapPage } from "../root"

interface Props {
  contents: any
  languageId: string
  slug: string
  category?: string
  preview: boolean
  rootData: any
  query: any
}

export default function EditorialPage({
  contents: data,
  // languageId,
  // slug,
  // category,
  rootData,
  query,
}: Props) {
  console.log("dynamic page")

  return (
    <WrapPage rootData={rootData}>
      <DefaultLayout>
        {data ? (
          <>
            <EditorialPageContainer contents={data} query={query} />
            <SeoContents page={data} />
          </>
        ) : (
          <>
            <PageNotFoundContainer />
            <GenericSEO
              title="Pagina non trovata"
              description="Pagina non trovata"
              noIndex
            />
          </>
        )}
      </DefaultLayout>
    </WrapPage>
  )
}

export async function getServerSideProps({ params, locale, query }: any) {
  return await wrapPage({
    locale,
    fetchProps: async (languageId: string) => {
      const slug = "faq"
      const category = ""
      const contents = await fetchEditorialPageData({
        query: faqQuery,
        languageId,
        slug,
        category,
      })
      return {
        slug,
        contents,
        category,
        query,
      }
    },
  })
}
